import React from 'react';

import BasePagination from 'components/Shared/Pagination';

export interface PaginationProps {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

export default function Pagination(props: PaginationProps): JSX.Element | null {
  return (
    <BasePagination
      onPageChange={props.onPageChange}
      totalResults={props.pageCount * 3}
      currentPage={props.currentPage}
      pageSize={3}
    />
  );
}
